const dev = 'http://localhost:8000'
const prod = "https://dev-task-app.duckdns.org/task"
export const baseurl = prod
